module.exports = __webpack_public_path__ + "iphone.89b98b5aa2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/home/iphone.png
// module id = ./src/styles/marketing/home/iphone.png
// module chunks = 21